import { combineReducers } from "redux";
import authReducer from "./authentication/reducers";
import { branchsReducer } from "./branchs/reducers";
import { userReducer } from "./users/reducers";
import { adminReducer } from "./userAdmin/reducers";
import { templatesReducer } from "./templates/reducers";
import { documentsReducer } from "./documents/reducers";
import { proyectsReducer } from "./proyects/reducers";
import { productsReducer } from "./products/reducers";
import { shoppingsReducer } from "./shoppings/reducers";
import { pendingProductsReducer } from "./pending-products/reducers";
import { warehousesReducer } from "./warehouses/reducers";
import { seminuevosReducer } from "./seminuevos/reducers";
import { employeesReducer } from "./employees/reducers";
import { movementsReducer } from "./movements/reducers";
import { transfersReducer } from "./transfers/reducers";
import { warrantiesReducer } from "./warranties/reducers";
import { warehouseRequestsReducer } from "./warehouseRequests/reducers";
import { vehiclesReducer } from "./vehicles/reducers";
import { activesReducer } from "./actives/reducers";

const rootReducers = combineReducers({
  auth: authReducer,
  branchs: branchsReducer,
  users: userReducer,
  userAdmin: adminReducer,
  templates: templatesReducer,
  documents: documentsReducer,
  proyects: proyectsReducer,
  products: productsReducer,
  shoppings: shoppingsReducer,
  pendingProducts: pendingProductsReducer,
  warehouses: warehousesReducer,
  seminuevos: seminuevosReducer,
  employees: employeesReducer,
  movements: movementsReducer,
  transfers: transfersReducer,
  warranties: warrantiesReducer,
  warehouseRequests: warehouseRequestsReducer,
  vehicles: vehiclesReducer,
  actives: activesReducer,
});

export type RootState = ReturnType<typeof rootReducers>;
export default rootReducers;
